import { CaseBase } from './base/case-base';

export class Case extends CaseBase { }